


// Vue
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

// Constants
import Assets from '@/constants/assets.ts';
import RouteNames from '@/constants/route-names';

// Components
import Card, { CardDecorationColor, CardNumber } from '@/shared/components/card.component.vue';
import Icon, { IconEnum } from '@/shared/components/icon.component.vue';
import Tooltip, { TooltipColor } from '@/shared/components/Tooltip.component.vue';

// Filters
import formatDate from '@/shared/filters/formatDate.filter.ts';
import formatPhone from '@/shared/filters/formatPhone.filter.ts';

// Services
import { ConvocationService, TypeOfProduct } from '@/manager/convocation/convocation.service';

// Models
import { ClientStatus, Client } from '@/manager/client/client.model';
import { Participant } from '@/manager/convocation/participant.model';
import { PurchasePaymentStatus, PurchaseCompletionStatus } from '@/clickbuy/purchase/models/purchase.model';

// Exports
export { CardDecorationColor, CardNumber };

export enum RibbonColor {
    Primary = 'ribbon--primary',
    Secondary = 'ribbon--secondary',
}

@Component({
    components: {
        Card,
        Icon,
        Tooltip,
    },
    computed: {
        ...mapGetters({
            getParticipant: 'getParticipant',
        }),
    },
    filters: {
        formatDate,
        formatPhone,
    },
})
export default class ParticipantCard extends Vue {
    @Prop() private participantId!: string;
    @Prop() private convocationId!: string;
    // Base component props
    @Prop({ default: CardNumber.Even }) private cardNumber!: string;


    private assets = Assets;
    private iconEnum = IconEnum;
    private tooltipColor = TooltipColor;
    private getParticipant!: any;


    get participant() {
        return this.getParticipant(this.participantId);
    }

    get participantPhone() {
        return this.participant.client.user.profile.phone;
    }

    get participantFullName() {
        return this.participant.client.user.fullName;
    }

    get participantEmail() {
        return this.participant.client.user.email;
    }

    get isPotential() {
        return this.participant.client.status === ClientStatus.Potential;
    }

    get isCustomer() {
        return this.participant.client.status === ClientStatus.Customer;
    }

    get tooltipIconText() {
        let text = 'Potencial';
        if ( this.isCustomer) {
            text = 'Cliente';
        }
        return text;
    }

    get clientStatusIcon() {
        let icon = this.iconEnum.TargetClient;
        if ( this.isCustomer ) {
            icon = this.iconEnum.Participant;
        }
        return icon;
    }

    get ribbonColorClass() {
        let ribbonClass = RibbonColor.Primary;
        if (
            PurchasePaymentStatus.Pending === this.participant.purchase.paymentStatus
        ) {
            ribbonClass = RibbonColor.Secondary;
        }
        return ribbonClass;
    }

    get cardDecorationColor() {
        let decorationColor = CardDecorationColor.Primary;
        if ( this.participant.purchase ) {
            decorationColor = CardDecorationColor.Secondary;
        }
        return decorationColor;
    }

    get ribbonText() {
        let text = 'pagado';
        if (
            PurchasePaymentStatus.Pending === this.participant.purchase.paymentStatus
        ) {
            text = 'pendiente';
        } else if (
            PurchaseCompletionStatus.Finished === this.participant.purchase.completionStatus
        ) {
            text = 'terminado';
        }
        return text;
    }

    get linkDestination() {
        let destination = '_self';
        if ( this.participant.purchase ) {
            destination = '_blank';
        }
        return destination;
    }

    get routerLinkTo() {
        let link: any = {
            name: RouteNames.cbPurchaseParticipant,
            params: {
                participantId: this.participant.id,
                convocationId: this.convocationId,
            },
        };
        if ( this.participant.purchase ) {
            link = {
                name: RouteNames.cbPurchase,
                params: {
                    purchaseId: this.participant.purchase.id,
                },
            };
        } else if ( this.isCustomer ) {
            link = {};
        }

        return link;
    }


    private cardClick() {
        if ( this.isCustomer && !this.participant.purchase ) {
            this.$emit('participant-clicked', this.participant);
        }
    }

    private patchPurchase(data: any) {
        const payload = {
            id: this.participant.purchase.id,
            participantId: this.participantId,
            data,
        };
        this.$store.dispatch('patchParticipantPurchase', payload).then(
            (res) => {
                //
            },
        );
    }

    private changePaymentStatus() {
        if ( this.participant.purchase.paymentStatus === PurchasePaymentStatus.Pending) {
            this.patchPurchase({ payment_status: PurchasePaymentStatus.Paid });
        }
    }
}

